import {SkillType} from 'Interfaces'
import {orderBy} from 'lodash'

export const Sort = (items: SkillType[]) =>
  orderBy(
    items,
    [(o) => o.skillLevel?.level, (o) => o.skill?.translation],
    ['desc', 'asc']
  )
